// @ts-nocheck
import '../../sass/pages/_cbhome.scss';

import '../components/mordernizr';
import Swiper, { Navigation, Pagination } from 'swiper';
import "swiper/css";
import 'animate.css';
Swiper.use([Navigation, Pagination]);
import * as AOS from 'aos';
import 'aos/dist/aos.css';
import * as Parallax from "parallax-js";
import { lazyLoad } from "../components/lazySizes";
import { particles } from "../components/animateParticles";

const stateHome = () => {
    const arrayNode = window.drupalSettings.path.currentPath.split("/");  

    fetch(`/get/co_clubco_convocatorias/status/evento/${arrayNode[1]}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    })
    .then(response => response.json())
    .then(json => {
        if(json.fase === 0) {
            document.querySelector('.cbhome__ambassadors')?.classList.remove('hidden');
        }
        if(json.fase === 1) {
            document.querySelector('#cbhome__security')?.classList.remove('hidden');
            // document.querySelector('.cbhome__searching')?.classList.remove('hidden'); 
            document.querySelector('.cbhome__ambassadors')?.classList.remove('hidden');
        }
        if(json.fase === 2) {
            const security1 = document.querySelector('#cbhome__security');
            const security2 = document.querySelector('.cbhome__security--steps');
            const favoriteEmprend = document.querySelector('.cbhome__favoriteEmprend');
            const containerCards = document.querySelector('.cbhome__favoriteEmprend--content')
            document.querySelector('.cbhome__searching .cbhome__searching--boxtitle')?.classList.remove('hidden')
            document.querySelector('.cbhome__searching .boxEntrepreneurship--title.title1')?.classList.add('hidden')
            document.querySelector('.cbhome__searching .boxEntrepreneurship--title.title2')?.classList.remove('hidden')
            document.querySelector('.cbhome__searching .boxEntrepreneurship--desc')?.classList.add('hidden')
            document.querySelector('.cbhome__searching .vote')?.classList.remove('hidden')
            document.querySelector('.cbhome__searching .register')?.classList.add('hidden')
            document.querySelector('.cbhome__searching')?.classList.remove('hidden');
            // const ambassadors = document.querySelector('.cbhome__ambassadors');
            
            security1?.classList.add('hidden');
            security2?.classList.remove('hidden')
            favoriteEmprend?.classList.remove('hidden')
            ambassadors?.classList.remove('hidden')

            const arrayEvent = json.record_empredimientos;
            if(arrayEvent.length > 0) {
                const controlsCss = {
                    'back1' : containerCards.getAttribute("data-bg-1"),
                    'colorName' : containerCards.getAttribute("data-color-name"),
                    'back2' : containerCards.getAttribute("data-bg-2"),
                    'colorText' : containerCards.getAttribute("data-color-text"),
                    'back3' : containerCards.getAttribute("data-bg-3"),
                }
                arrayEvent.map( e => {
                    let containerEprend = document.createElement('DIV')
                    containerEprend.classList.add('cardEmprend');
                    
                    containerEprend.innerHTML += 
                        `
                            ${e.url_image == 'null' || e.url_image == null || e.url_image == "" ? 
                                `
                                <p class="notImg" style="color:${controlsCss.colorName};background-color: ${controlsCss.back1};">
                                    <span class="cbhome--decoR">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="45" viewBox="0 0 22 45" fill="none">
                                            <path d="M22 0.249999L19.6532 13.4986L10.9953 3.20452L15.5861 15.8454L2.94518 11.2547L13.2393 19.9032L-9.61651e-07 22.25L13.2393 24.5968L2.94518 33.2547L15.5861 28.6639L10.9953 41.3048L19.6532 31.0107L22 44.25L22 0.249999Z" fill="${controlsCss.colorName}"></path>
                                        </svg>
                                    </span>
                                    ${e.name_entre}
                                    <span class="cbhome--decoL">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="45" viewBox="0 0 22 45" fill="none">
                                            <path d="M22 0.249999L19.6532 13.4986L10.9953 3.20452L15.5861 15.8454L2.94518 11.2547L13.2393 19.9032L-9.61651e-07 22.25L13.2393 24.5968L2.94518 33.2547L15.5861 28.6639L10.9953 41.3048L19.6532 31.0107L22 44.25L22 0.249999Z" fill="${controlsCss.colorName}"></path>
                                        </svg>
                                    </span>
                                </p>
                                `
                                : 
                                `
                                    <picture>
                                        <img src="${e.url_image}" title="fondo time" alt="fondo time">
                                    </picture>
                                `
                            }
                            <div class="content" style="background-image: url('${controlsCss.back2}');">
                                <h3 style="color:${controlsCss.colorText}">${e.name_entre}</h3>
                                <div class="content__instagram">
                                    <picture>
                                        <img src="${window.drupalSettings.path.themeUrl}/vendor/sources/dist/assets/images/carnaval/icons/iconinstagramEmpre.png" title="ig" alt="ig">
                                    </picture>
                                    <p style="color:${controlsCss.colorText}">${e.instagram_entre}</p>
                                </div>
                                <a href="#" class="content__btn" style="background-color: ${controlsCss.back3}; border: 1px solid ${controlsCss.back3}; color:${controlsCss.colorText}">${e.category_entre}</a>
                                <p class="content__text" style="color:${controlsCss.colorText}">
                                    ${e.description}
                                </p>
                            </div>
                        `;
                    containerCards?.appendChild(containerEprend);
                })
            } else {
                let containerEprend = document.createElement('DIV')
                containerEprend.classList.add('cardEmprend');
                
                containerEprend.innerHTML += `<p class="noHay">No hay emprendimientos registrados</p>`;
                containerCards?.appendChild(containerEprend);

                containerCards?.closest('.cbhome__favoriteEmprend--content')?.nextElementSibling?.classList.add('hidden')

            }
        }
        if(json.fase === 3) {
            const security1 = document.querySelector('#cbhome__security');
            const ambassadors = document.querySelector('.cbhome__ambassadors');
            const favoriteEmprendSlider = document.querySelector('#cbhome__favoriteEmprend--slider');
            const countdown = document.querySelector('#cbhome__countdown');
            const searching = document.querySelector('.cbhome__searching');
            const containerCards = document.querySelector('.cbhome__favoriteEmprend--swiper .swiper-wrapper')
            
            security1?.classList.add('hidden');
            ambassadors?.classList.remove('hidden')
            countdown?.classList.add('hidden')
            favoriteEmprendSlider?.classList.remove('hidden')
            searching?.classList.add('hidden')

            const arrayEvent = json.record_empredimientos_award
            
            const controlsCss = {
                'back1' : containerCards.getAttribute("data-bg-1"),
                'colorName' : containerCards.getAttribute("data-color-name"),
                'back2' : containerCards.getAttribute("data-bg-2"),
                'colorText' : containerCards.getAttribute("data-color-text"),
                'back3' : containerCards.getAttribute("data-bg-3"),
            }
            
            arrayEvent.map( e => {
                let containerEprend = document.createElement('DIV')
                containerEprend.classList.add('swiper-slide');
                
                containerEprend.innerHTML += 
                    `
                    <div class="cardEmprend">
                        ${e.url_image == 'null' || e.url_image == null || e.url_image == "" ? 
                            `
                                <p class="notImg" style="color:${controlsCss.colorName};background-color: ${controlsCss.back1};">
                                    <span class="cbhome--decoR">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="45" viewBox="0 0 22 45" fill="none">
                                            <path d="M22 0.249999L19.6532 13.4986L10.9953 3.20452L15.5861 15.8454L2.94518 11.2547L13.2393 19.9032L-9.61651e-07 22.25L13.2393 24.5968L2.94518 33.2547L15.5861 28.6639L10.9953 41.3048L19.6532 31.0107L22 44.25L22 0.249999Z" fill="${controlsCss.colorName}"></path>
                                        </svg>
                                    </span>
                                    ${e.name_entre}
                                    <span class="cbhome--decoL">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="45" viewBox="0 0 22 45" fill="none">
                                            <path d="M22 0.249999L19.6532 13.4986L10.9953 3.20452L15.5861 15.8454L2.94518 11.2547L13.2393 19.9032L-9.61651e-07 22.25L13.2393 24.5968L2.94518 33.2547L15.5861 28.6639L10.9953 41.3048L19.6532 31.0107L22 44.25L22 0.249999Z" fill="${controlsCss.colorName}"></path>
                                        </svg>
                                    </span>
                                </p>
                            `
                            : 
                            `
                                <picture>
                                    <img src="${e.url_image}" title="fondo time" alt="fondo time">
                                </picture>
                            `
                        }
                        <div class="content" style="background-image: url('${controlsCss.back2}');">
                                <h3 style="color:${controlsCss.colorText}">${e.name_entre}</h3>
                                <div class="content__instagram">
                                    <picture>
                                        <img src="${window.drupalSettings.path.themeUrl}/vendor/sources/dist/assets/images/carnaval/icons/iconinstagramEmpre.png" title="ig" alt="ig">
                                    </picture>
                                    <p style="color:${controlsCss.colorText}">${e.instagram_entre}</p>
                                </div>
                                <a href="#" class="content__btn" style="background-color: ${controlsCss.back3}; border: 1px solid ${controlsCss.back3}; color:${controlsCss.colorText}">${e.category_entre}</a>
                                <p class="content__text" style="color:${controlsCss.colorText}">
                                    ${e.description}
                                </p>
                            </div>
                    </div>
                    `;
                containerCards?.appendChild(containerEprend);
            })
        }
        if(json.fase === 'CLOSED_EVENT') {
            // document.querySelector('.cbhome__ambassadors')?.classList.remove('hidden');
            document.querySelector('#cbhome__countdown')?.classList.add('hidden');
        }
    })
    .catch((err: any) => {
        console.log(err)
    });
}

function carousels(){
    const swiper = new Swiper('.swiperhomeCarnival', {
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },        
        breakpoints: {
            991: {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
        },
    });
	const swiperBenefits = new Swiper('.swiperBenefits', {
        slidesPerView: 'auto',
        spaceBetween: 30, 
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
	const favoriteEmprendSwiper = new Swiper('.favoriteEmprendSwiper', {
        slidesPerView: 1,
        spaceBetween: 0, 
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1278: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
    });

	const swiperDetails = new Swiper('.swiperDetails', {
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },  
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    const swiperAmbassadors = new Swiper('.swiperAmbassadors', {
        slidesPerView: 1,
        spaceBetween: 30,
        // loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 0,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
        },
    });

    btnFloatswiper();
    colorsbtnSlider();
}

const colorsbtnSlider = () => {
    let color = document.querySelector('.swiperDetails .swiper-pagination') as any;
    let btns = document.querySelectorAll('.swiperDetails .swiper-pagination span') as any;
    btns.forEach(function(e){
        if(e.classList.contains('swiper-pagination-bullet-active')){
            e.style.background = color.getAttribute('data-color');
        }
        e.addEventListener('click', function(){
            e.style.background = color.getAttribute('data-color');
        })
    })
}

function btnFloatswiper() {
    const btnNext = document.querySelector('.btn-next')
    const btnPrev = document.querySelector('.btn-prev')

    btnNext?.addEventListener('click', e => {
        e.preventDefault()
        const btnNextSwiper:any = document.querySelector('.favoriteEmprendSwiper .swiper-button-next')
        btnNextSwiper.click()
    })
    btnPrev?.addEventListener('click', e => {
        e.preventDefault()
        const btnPrevSwiper:any = document.querySelector('.favoriteEmprendSwiper .swiper-button-prev')
        btnPrevSwiper.click()
    })
}

/*function loadParallax() {
    var scene1 = document.querySelector(".boxFlowers");
    var parallax1 = new Parallax(scene1);

    var scene2 = document.querySelector(".boxFlowers2");
    var parallax3 = new Parallax(scene2);
}*/

(function page() {
	lazyLoad();
    carousels();
    //loadParallax();
    stateHome();
    particles('cbhome__countdown');
    particles('cbhome__security');
    AOS.init({
        once: true,
    });
})()